import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Manifesto } from "@/components/home/Manifesto";
import { Stats } from "@/components/home/Stats";
import { Collection } from "@/components/home/Collection";
import { Spaces } from "@/components/home/Spaces";
import { Global } from "@/components/home/Global";
import { Infrastructure } from "@/components/home/Infrastructure";
import { Catalogues } from "@/components/home/Catalogues";
import { Calculator } from "@/components/home/Calculator";
import { Testimonials } from "@/components/home/Testimonials";
import { Enquiry } from "@/components/home/Enquiry";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Manifesto />
      <Stats />
      <Collection />
      <Spaces />
      <Global />
      <Infrastructure />
      <Catalogues />
      <Calculator />
      <Testimonials />
      <Marquee dark />
      <Enquiry />
    </main>
  );
}
